define('SageDotCom/DataLayer/Events/blog-click',[
    'SageDotCom/DataLayer/Events/eventBase'
], function (EventBase) {

    function BlogClickEvent(article) {
        EventBase.call(this); 
        this.name = 'blog_click';

        this.props = {
            'event_name': this.getName(),
            'event_non-int': '0',
            'event_category': 'interaction',
            'event_action': this.getName(),
            'event_label': article.title,
            'event_name_level_1': '(not set)',
            'event_name_level_2': article.url,
            'event_name_level_3': article.id,
            'event_name_level_4': article.category
        };
    }

    BlogClickEvent.prototype = Object.create(EventBase.prototype);

    return BlogClickEvent;
});
